<app-header *ngIf="!this.authService.isAdmin"></app-header>
<app-administrator-header *ngIf="this.authService.isAdmin"> </app-administrator-header>

<!-- main body div has the css to hold the footers to bottom -->
<div id="main-body">
    <app-loading-spinner *ngIf="showOverlay"></app-loading-spinner>
    <router-outlet *ngIf="!showOverlay" (activate)="onActivate($event)"></router-outlet>
</div>

<app-administrator-footer *ngIf="this.authService.isAdmin"></app-administrator-footer>
<footer *ngIf="!this.authService.isAdmin" class="section footer-creative context-dark">
    <div class="footer-creative-main">
        <div class="container">
            <div class="row row-50 justify-content-lg-between">
                <div class="col-sm-6">
                    <p class="footer-creative-title ">Συνδεσμοι</p>
                    <div class="footer-creative-divider "></div>
                    <div *ngIf="authService.isCompany() || authService.isCandidate();else notSigned " class="row row-narrow row-15 ">
                        <div class="col-sm-6 ">
                            <ul class="list-marked-1">
                                <li *ngIf="authService.isCompany() && !authService.isValidCompany "><a class="myAnchor " (click)="searchForJob() ">Θέσεις Εργασίας</a></li>
                                <li *ngIf="authService.isCompany() && authService.isValidCompany "><a class="myAnchor " (click)="companyJobListing() ">Θέσεις εργασίας της εταιρείας</a></li>
                                <li *ngIf="authService.isCandidate() "><a class="myAnchor " (click)="searchForJob() ">Αναζήτηση θέσης Εργασίας</a></li>
                                <li *ngIf="authService.isCompany() && authService.isValidCompany "><a class="myAnchor " (click)="companyPostAJob() ">Ανάρτηση νέας Θέσης Εργασίας</a></li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <ul class="list-marked-1 ">
                                <li *ngIf="authService.isCompany() "><a class="myAnchor " (click)="searchForCandidate() ">Αναζήτηση Υποψηφίου</a></li>
                                <!-- <li><a routerLink="/faq ">FAQ </a></li> -->
                            </ul>
                        </div>
                    </div>
                    <ng-template #notSigned>
                        <div class="row row-narrow row-15 ">
                            <div class="col-sm-6 ">
                                <ul class="list-marked-1">
                                    <li><a class="myAnchor" (click)="searchForJob()">Αναζήτηση θέσης Εργασίας</a></li>
                                    <li><a class="myAnchor" (click)="onUnsignedPostAJob()">Ανάρτηση νέας Θέσης Εργασίας</a></li>
                                    <li *ngIf="chamberFacebook !== ''">
                                        <a [href]= "chamberFacebook" target="_blank">Ακολουθήστε μας στο Facebook</a></li>
                                </ul>
                            </div>
                            <div class="col-sm-6 ">
                                <ul class="list-marked-1">
                                    <li><a class="myAnchor" (click)="onUnsignedCandidateListing()">Αναζήτηση Υποψηφίου</a></li>
                                    <!-- <li><a class="myAnchor" routerLink="/faq">FAQ</a></li> -->
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </div>

                <!-- popular locations -->
                <div class="col-sm-6">
                    <p class="footer-creative-title ">Δημοφιλεις Περιοχες</p>
                    <div class="footer-creative-divider"></div>
                    <div class="row row-narrow row-15 ">
                        <div class="col-sm-6">
                            <ul>
                                <li *ngFor="let location Of popularLocations; let i=index ">
                                    <button *ngIf="i<3 " style=" color: white; font-size: 0.9rem " type="submit " class=" btn btn-link " (click)="jobPostsByLocation(location[0]) "><span
                                            class="icon icon-sm mdi mdi-map-marker "></span><span>{{location[0]}}</span></button></li>
                            </ul>
                        </div>

                        <div class="col-sm-6">
                            <ul>
                                <li *ngFor="let location Of popularLocations; let i=index ">
                                    <button *ngIf="i>=3" style="color: white; font-size: 0.9rem;" type="submit " class="btn btn-link" (click)="jobPostsByLocation(location[0])"><span class="icon icon-sm mdi mdi-map-marker "></span><span>{{location[0]}}</span></button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-creative-aside ">
        <div class="container ">
            <img src="assets/images/espa/espa.jpg"> 
            <p class="rights "><a class="myAnchor " href="http://www.knowledge.gr/ksa/shared/index.jsp?context=101 " target="_blank ">Knowledge Broadband Services {{currentYear}}</a><span>&nbsp;&copy;&nbsp;</span><span class="copyright-year "></span><span>&nbsp;</span>
                <a [routerLink]="['/privacy'] ">Privacy Policy</a>                          
            </p>
        </div>
    </div>
</footer>